import React from 'react'
import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'
import classNames from 'classnames/bind'
import { upperFirstOnly } from 'utils/format'
import styles from './DateHeader.module.scss'
import { getTableCellStickyStyle } from '../../../../utils'
import { KeyPerformanceMetrics } from 'utils/constants'

const cx = classNames.bind(styles)

const DateHeader = ({ stickyConfig, activeTab }) => {
  const { t } = useTranslation()

  return (
    <th
      className={cx('date-header', { 'key-performance-metrics': activeTab === KeyPerformanceMetrics })}
      style={getTableCellStickyStyle(stickyConfig, true) || {}}
    >
      <div>{upperFirstOnly(t('widgets.performanceReport.date'))}</div>
    </th>
  )
}

DateHeader.propTypes = {
  stickyConfig: PropTypes.shape({
    width: PropTypes.number,
    left: PropTypes.number,
    zIndex: PropTypes.number
  }),
  activeTab: PropTypes.string
}

DateHeader.defaultProps = {
  stickyConfig: null,
  activeTab: null
}

export { DateHeader }
